/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ExchangeInputs */

const cs_enum_exchange = /** @type {(inputs: Enum_ExchangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výměna`)
};

const en_enum_exchange = /** @type {(inputs: Enum_ExchangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exchange`)
};

/**
* | output |
* | --- |
* | "Exchange" |
*
* @param {Enum_ExchangeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_exchange = /** @type {((inputs?: Enum_ExchangeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ExchangeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_exchange(inputs)
	return cs_enum_exchange(inputs)
});